import { render, staticRenderFns } from "./ym-sales-volume-detail.vue?vue&type=template&id=35285011&scoped=true&"
import script from "./ym-sales-volume-detail.vue?vue&type=script&lang=js&"
export * from "./ym-sales-volume-detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35285011",
  null
  
)

export default component.exports